import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from '../GenericNavigation/generic-navigation.module.scss'
import IconMenu from '@BUP/components/IconMenu'

const FinanceNavigation = () => {
  const [t] = useTranslation()
  const getNavLinkClassName = ({ isActive }) =>
    classNames(styles.nav_link, { [styles.active]: isActive, active: isActive })

  return (
    <nav className={styles.navigation_wrapper}>
      <div className={styles.links_wrapper}>
        <div className={styles.element_wrapper}>
          <NavLink to='/schoolpage' className={getNavLinkClassName}>
            <IconMenu iconName='school' />
            <span className={styles.nav_label}>{t('nav.mySchool')}</span>
          </NavLink>
        </div>
      </div>
    </nav>
  )
}

export default FinanceNavigation
